// @ vendors
import React, { Fragment } from 'react';

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
// @ commons
import { formatText } from 'core/i18n';
// @ components
import { RadioButton } from 'components/RadioButton/RadioButton';
const HasPEP = require('components/hasPEP/hasPEP');
const TaxationQuestions = require('components/taxationQuestions/taxationQuestions').TaxationQuestions;
const AccountMoney = require('components/accountMoney/accountMoney');
const AccountUse = require('components/accountUse/accountUse').accountUse;
const BlockWrapper = require('components/blockWrapper/blockWrapper');
const Patrimony = require('components/incomes/patrimony/patrimony');
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
// @ utilities
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
// @ actions
const accountTypeActions = require('actions/accountTypeActions');
import { CREDIT_CARD } from 'constants/userProfile';
import { FiocTgssConsent } from './components/FiocTgssConsent';
import { FundsOriginDeclaration } from 'components/FundsOriginDeclaration/FundsOriginDeclaration';
import { ONBOARDING_FLAG_WEB_FIOC_RESPONSE_NO_ACT } from 'constants/featureFlagging';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

class withoutActivity extends React.Component {
    constructor(props) {
        super(props);
        this.onHandleSave = this.onHandleSave.bind(this);
        this.buildProfession = this.buildProfession.bind(this);
        this.buildDefaultQuestions = this.buildDefaultQuestions.bind(this);
        this.buildReducedQuestions = this.buildReducedQuestions.bind(this);
    }

    onHandleSave(name, value) {
        const { userProfile, goToErrorsView } = this.props;
        const data = {};
        const accessToken = userProfile.accessToken;
        data[name] = value;
        this.props.accountTypeActions.saveUnemployedInformation(data, accessToken, (saved, errors) => {
            if (!saved) {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002 });
                }
            }
        });
    }

    buildProfession() {
        const { userProfile } = this.props;
        const onHandleSave = this.onHandleSave;

        return (
            <RadioButton
                label={formatText('field-whatDoYouWorkOn')}
                profileModel="userProfile.withoutActivity_activity"
                optionsList={[
                    {
                        label: formatText('field-otherActivities_item_2'),
                        value: 'X200A',
                    },
                    {
                        label: formatText('field-otherActivities_item_3'),
                        value: 'X300A',
                    },
                    {
                        label: formatText('field-otherActivities_item_1'),
                        value: 'X300B',
                    },
                ]}
                isRequired
                isUpdated={function () {
                    onHandleSave('profession', userProfile.withoutActivity_activity);
                }}
                focusAnimated
                {...this.props}
            />
        );
    }

    buildDefaultQuestions() {
        const { userProfile, shouldRenderTgssQuestion, formActions, userProfileForm, flags } = this.props;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);
        const isFiocResponseNoActFlagActive = flags.get(ONBOARDING_FLAG_WEB_FIOC_RESPONSE_NO_ACT);
        let positionCounter = 0;

        return (
            <div>
                <BlockWrapper position={positionCounter} visible={true}>
                    <div className="row md-form-group">
                        <div className="col-sm-8">{this.buildProfession()}</div>
                    </div>
                </BlockWrapper>

                <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                    <Fragment>
                        <BlockWrapper
                            position={++positionCounter}
                            visible={false}
                            firstValue={userProfile.withoutActivity_activity}
                        >
                            <div className="row">
                                <div className="col-sm-12 md-form-group">
                                    <Patrimony handleSave={this.onHandleSave} {...this.props} />
                                </div>
                            </div>
                        </BlockWrapper>
                        {isFiocResponseNoActFlagActive && (
                            <BlockWrapper
                                position={++positionCounter}
                                visible={false}
                                firstValue={userProfile.is_patrimony}
                            >
                                <div className="row">
                                    <FundsOriginDeclaration handleSave={this.onHandleSave} {...this.props} />
                                </div>
                            </BlockWrapper>
                        )}
                        <BlockWrapper
                            position={++positionCounter}
                            visible={false}
                            firstValue={
                                isFiocResponseNoActFlagActive ? userProfile.is_fundsOrigin : userProfile.is_patrimony
                            }
                        >
                            <div className="row">
                                <div className="md-form-group col-sm-12">
                                    <HasPEP
                                        profileModel="userProfile.withoutActivity_hasPEP"
                                        hideIncomes
                                        {...this.props}
                                        handleSave={this.onHandleSave}
                                    />
                                </div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper
                            position={++positionCounter}
                            visible={false}
                            firstValue={userProfile.withoutActivity_hasPEP}
                        >
                            <div className="row">
                                <div className="md-form-group col-lg-12">
                                    <AccountMoney
                                        profileModel="userProfile.withoutActivity_accountMoney"
                                        {...this.props}
                                        handleSave={this.onHandleSave}
                                    />
                                </div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper
                            position={++positionCounter}
                            visible={false}
                            firstValue={userProfile.withoutActivity_accountMoney}
                        >
                            <div className="row">
                                <div className="md-form-group col-lg-12">
                                    <AccountUse
                                        profileModel="userProfile.withoutActivity_accountUse"
                                        accountTypes={['personal', 'other']}
                                        hasPEP={true}
                                        {...this.props}
                                        handleSave={this.onHandleSave}
                                    />
                                </div>
                            </div>
                        </BlockWrapper>

                        <BlockWrapper
                            position={++positionCounter}
                            visible={false}
                            firstValue={userProfile.withoutActivity_accountUse}
                        >
                            <div className="row">
                                <div className="md-form-group col-lg-12">
                                    <TaxationQuestions {...this.props} handleSave={this.onHandleSave} />
                                </div>
                            </div>
                        </BlockWrapper>

                        {shouldRenderTgssQuestion && (
                            <BlockWrapper
                                position={++positionCounter}
                                visible={false}
                                firstValue={userProfile.withoutActivity_accountUse}
                            >
                                <div className="row">
                                    <div className="col-lg-12 md-form-group">
                                        <FiocTgssConsent
                                            formActions={formActions}
                                            userProfileForm={userProfileForm}
                                            userProfile={userProfile}
                                        />
                                    </div>
                                </div>
                            </BlockWrapper>
                        )}
                    </Fragment>
                </ConditionalToggling>
            </div>
        );
    }

    buildReducedQuestions() {
        const profession = this.buildProfession();
        const { userProfile, shouldRenderTgssQuestion, formActions, userProfileForm } = this.props;

        return (
            <div>
                <BlockWrapper position={0} visible={true}>
                    <div className="row md-form-group">
                        <div className="col-sm-8">{profession}</div>
                    </div>
                </BlockWrapper>

                {shouldRenderTgssQuestion && (
                    <BlockWrapper position={1} visible={false} firstValue={userProfile.withoutActivity_activity}>
                        <div className="row">
                            <div className="col-lg-12 md-form-group">
                                <FiocTgssConsent
                                    formActions={formActions}
                                    userProfileForm={userProfileForm}
                                    userProfile={userProfile}
                                />
                            </div>
                        </div>
                    </BlockWrapper>
                )}
            </div>
        );
    }

    render() {
        const { userProfile } = this.props;
        const questios =
            userProfile.isJointHolder && getIsAuthorized(userProfile.jointHolderType)
                ? this.buildReducedQuestions()
                : this.buildDefaultQuestions();

        return questios;
    }
}

module.exports.constructor = withoutActivity;
module.exports.withoutActivity = connect(
    state => ({
        extraData: state.extraData,
        flags: state.featureFlagging.get('data'),
    }),
    dispatch => ({
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(withoutActivity);
